import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  humidityZone: {},
  district: undefined,
  region: undefined,
  locality: undefined,
  humidity: undefined,
  subject: undefined
};

const humidityZoneSlice = createSlice({
  name: 'humidityZone',
  initialState,
  reducers: {
    setHumidityZone: (state, action) => {
      state.humidityZone = action.payload;
    },
    setDistrict: (state, action) => {
      state.district = action.payload;
    },
    setRegion: (state, action) => {
      state.region = action.payload;
    },
    setLocality: (state, action) => {
      state.locality = action.payload;
    },
    setHumidity: (state, action) => {
      state.humidity = action.payload;
    },
    setSubject: (state, action) => {
      state.subject = action.payload;
    },
    resetHumidityZone: (state) => {
      const humidityZone = state.humidityZone;
      return {...initialState, humidityZone};
    },
  },
});

export const { 
  setDistrict, 
  setRegion, 
  setLocality, 
  setHumidity, 
  setHumidityZone,
  setSubject,
  resetHumidityZone
} = humidityZoneSlice.actions;

export default humidityZoneSlice.reducer;